import { Card } from 'components/Card'
import { CoverBackground } from 'components/CoverBackground'
import Link, { LinkProps } from 'next/link'
import { transparentize } from 'polished'
import { ComponentType } from 'react'
import { GoChevronRight } from 'react-icons/go'
import styled from 'styled-components'

const Title = styled.h6`
  margin-bottom: 16px;
  color: #757d88;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;

  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const Cover = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: 5px;
  opacity: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => transparentize(0.3, theme.colors.blue)};

  color: white;
  font-weight: 600;
  font-size: 15px;
  line-height: 18px;
  text-shadow: 0 1px 2px 0 #00538c;

  :hover {
    opacity: 1;
  }
`

const Background = styled(CoverBackground)`
  height: 0;
  padding-bottom: 75%;
  border-radius: 5px;
`

interface Props extends LinkProps {
  title: string
  text: string
  image?: string
}

export const LinkCard: ComponentType<Props> = ({ title, text, image, ...props }) => (
  <div>
    <Title>{title}</Title>
    <Link {...props}>
      <a>
        <Card>
          <Cover>
            {text} <GoChevronRight />
          </Cover>
          <Background url={image} />
        </Card>
      </a>
    </Link>
  </div>
)
